module.exports = __webpack_public_path__ + "static/media/loader-checkout-postventa-izq.719a3a8e.gif";